export const API_PATH_apiUsersInvitationsPost = '/services/users-invitations';
